module.exports = __webpack_public_path__ + "ejemploa2(c).png?295c0a9d25e4d4133d405f9baf0b852f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ejemploa2(c).png
// module id = 504
// module chunks = 0